/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select({
  web: () => require("./NavBar.web").default,
  default: () => () => null,
})();
